/* ==========================================================================
   hp-material-note.js

   Behaviour for the gallery info button (snippets/hp-material-note-gallery).
   The buy box row is a plain <details> and needs nothing from here.

   - hover the button        opens the note on desktop (mouse/trackpad only),
                             moving away closes it after a short pause
   - click the button        pins the note open, or closes it if pinned
   - click anywhere else     closes it
   - Escape                  closes it and puts focus back on the button
   - swipe past image one    hides the button (mobile mosaic and the slider),
                             since it belongs to the first image
   ========================================================================== */
(function () {
  'use strict';

  // Real pointer hover only. Phones fire fake mouseenter on tap, which would
  // fight the click handler, so they never get the hover behaviour.
  var canHover = window.matchMedia
    ? window.matchMedia('(hover: hover) and (pointer: fine)')
    : { matches: false };

  function setOpen(note, open) {
    var btn = note.querySelector('[data-hp-mnote-btn]');
    note.classList.toggle('is-open', open);
    if (!open) note.classList.remove('is-pinned');
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }

  function closeAll(except) {
    document.querySelectorAll('[data-hp-mnote].is-open').forEach(function (n) {
      if (n !== except) setOpen(n, false);
    });
  }

  function bindScrollHide(note) {
    var media = note.closest('.hp-media');
    if (!media) return;

    // Mosaic turns into a horizontal swipe row under 750px; the slider
    // scrolls its viewport at every width. Desktop mosaic never scrolls
    // sideways, so the listener simply never fires there.
    var track = media.querySelector('[data-hp-slider-track]') ||
                media.querySelector('[data-hp-grid]');
    if (!track) return;

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var away = Math.abs(track.scrollLeft) > track.clientWidth * 0.5;
        note.classList.toggle('is-away', away);
        if (away) setOpen(note, false);
      });
    }, { passive: true });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-hp-mnote]').forEach(function (note) {
      if (note.dataset.hpMnoteReady) return;
      note.dataset.hpMnoteReady = '1';

      var btn = note.querySelector('[data-hp-mnote-btn]');
      if (!btn) return;

      var leaveTimer = null;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        clearTimeout(leaveTimer);
        closeAll(note);

        // Opened by hover and not yet pinned: the click pins it, so the
        // note stays put instead of snapping shut under the cursor.
        if (note.classList.contains('is-open') && !note.classList.contains('is-pinned')) {
          note.classList.add('is-pinned');
          return;
        }

        var open = !note.classList.contains('is-open');
        setOpen(note, open);
        if (open) note.classList.add('is-pinned');
      });

      note.addEventListener('mouseenter', function () {
        if (!canHover.matches || note.classList.contains('is-away')) return;
        clearTimeout(leaveTimer);
        if (note.classList.contains('is-open')) return;
        closeAll(note);
        setOpen(note, true);
      });

      note.addEventListener('mouseleave', function () {
        if (!canHover.matches || note.classList.contains('is-pinned')) return;
        clearTimeout(leaveTimer);
        leaveTimer = setTimeout(function () { setOpen(note, false); }, 180);
      });

      // Clicks inside the card (selecting text, say) should not close it.
      var tip = note.querySelector('.hp-mnote__tip');
      if (tip) tip.addEventListener('click', function (e) { e.stopPropagation(); });

      bindScrollHide(note);
    });
  }

  document.addEventListener('click', function () { closeAll(); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-hp-mnote].is-open');
    if (!open) return;
    setOpen(open, false);
    var btn = open.querySelector('[data-hp-mnote-btn]');
    if (btn) btn.focus();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-bind when the section is re-rendered after a setting change.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
